module.exports = __webpack_public_path__ + "static/media/inc.46da4baf.png";